import { toString } from 'lodash-es';
import type { PaginatedResourceList, ResourceListItemFront } from '../../models/resources.model';
import type {
  ResourceDataFileResourceListResponseBffApi,
  ResourceDataFileResourceReadBffApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import { mapMimeTypeToIconCategory } from '../../../utils/resourceIconCategory.util';
import { toIsoInstant } from '../utils/date.utils';

function mapResource(item: ResourceDataFileResourceReadBffApi): ResourceListItemFront {
  return {
    id: toString(item.id),
    name: toString(item.name),
    description: toString(item.description),
    creationDate: toIsoInstant(item.creationDate),
    organizationName: item.parentEntityRef.name,
    organizationId: toString(item.parentEntityRef.id),
    createdBy: item.createdBy.name,
    filename: item.artifact.fileName,
    extension: item.artifact.extension.toUpperCase(),
    mimeType: item.artifact.mimeType,
    sizeBytes: item.artifact.size,
    iconCategory: mapMimeTypeToIconCategory(item.artifact.mimeType),
  };
}

export function mapResourcesListResponseApiToPaginatedResourceList(
  response: ResourceDataFileResourceListResponseBffApi,
): PaginatedResourceList {
  const data = Array.isArray(response.data) ? response.data : [];

  return {
    pagination: (response.pagination as PaginatedResourceList['pagination']) ?? {
      totalResults: 0,
      startIndex: 0,
      itemsPerPage: 0,
    },
    data: data.map((resource) => mapResource(resource)),
  };
}
